<template>
  <v-app id="inspire">
    <v-snackbar v-model="alert" :timeout="6000" :top="true">
      {{ message }}
      <v-btn color="pink" flat @click="alert = false">Close</v-btn>
    </v-snackbar>
    <v-content>
      <v-dialog v-model="newPasswordRequired" max-width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">New Password Required</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-form>
                <v-layout wrap>
                  <v-flex xs12 sm6 md8>
                    <v-text-field
                      v-model="newPassword1"
                      label="Password"
                      type="password"
                      :error-messages="validatePasswords()"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPassword2"
                      label="Confirm Password"
                      type="password"
                      :error-messages="validatePasswords()"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="submitPassword">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="passwordResetRequired" max-width="500px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline">Password Reset</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <h4>A verification code has been sent to {{ emailDesitnation }}.</h4>
                <br>
                <h4>Please reset your password.</h4>
              </v-layout>
              <v-form>
                <v-layout wrap>
                  <v-flex xs12 sm6 md8>
                    <v-text-field v-model="verificationCode" label="Verification Code"></v-text-field>
                    <v-text-field
                      v-model="newPassword1"
                      label="New Password"
                      type="password"
                      :error-messages="validatePasswords()"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPassword2"
                      label="Confirm Password"
                      type="password"
                      :error-messages="validatePasswords()"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="submitPasswordReset">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    prepend-icon="person"
                    name="login"
                    label="Email"
                    type="text"
                    v-model="username"
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn small flat @click="forgotPassword">Forgot Password?</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Submit</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
const utils = require("./utils");
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
var poolData = {
  UserPoolId: utils.userPoolID,
  ClientId: utils.appClientID
};
var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

export default {
  name: "Login",
  data: () => ({
    username: "",
    password: "",
    newPassword1: "",
    newPassword2: "",
    alert: false,
    newPasswordRequired: false,
    passwordResetRequired: false,
    message: "",
    sessionAttributes: {},
    requiredAttributes: {},
    cogintoUser: {},
    emailDesitnation: "",
    verificationCode: ""
  }),
  methods: {
    validatePasswords() {
      return this.newPassword1 === this.newPassword2
        ? ""
        : "passwords do not match";
    },
    submitPasswordReset() {
      const showErrorMessage = err => {
        this.message = err.message || JSON.stringify(err);
        this.alert = true;
      };

      this.passwordResetRequired = false;

      this.cognitoUser.confirmPassword(
        this.verificationCode,
        this.newPassword1,
        {
          onSuccess() {
            showErrorMessage(
              "Password successfully rest. Please log in again."
            );
          },
          onFailure(err) {
            showErrorMessage(err);
          }
        }
      );
    },

    forgotPassword() {
      const showErrorMessage = err => {
        this.message = err.message || JSON.stringify(err);
        this.alert = true;
      };

      if (this.username === "") {
        showErrorMessage("Please enter your email");
        return;
      }

      var userData = {
        Username: this.username,
        Pool: userPool
      };

      this.cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      this.cognitoUser.forgotPassword({
        onSuccess: data => {
          this.passwordResetRequired = true;
          this.emailDesitnation = data.CodeDeliveryDetails.Destination;
        },
        onFailure: function(err) {
          showErrorMessage(err);
        }
      });
    },
    submitPassword() {
      const showErrorMessage = err => {
        this.message = err.message || JSON.stringify(err);
        this.alert = true;
      };

      const loginSuccess = this.loginSuccess;

      this.newPasswordRequired = false;
      this.cognitoUser.completeNewPasswordChallenge(
        this.newPassword1,
        this.sessionAttributes,
        {
          onSuccess: result => {
            var accessToken = result.getAccessToken().getJwtToken();
            loginSuccess(accessToken);
          },
          onFailure: err => {
            showErrorMessage(err);
          }
        }
      );
    },

    loginSuccess(accessToken) {
      window.sessionStorage.setItem("token", accessToken);
      this.$router.push({ path: "score" });
    },

    login() {
      const loginSuccess = this.loginSuccess;
      const showErrorMessage = err => {
        this.message = err.message || JSON.stringify(err);
        this.alert = true;
      };

      const requireNewPassword = (attr, required) => {
        this.sessionAttributes = attr;
        this.requiredAttributes = required;
        this.newPasswordRequired = true;
      };

      var authenticationData = {
        Username: this.username,
        Password: this.password
      };
      var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
        authenticationData
      );
      var userData = {
        Username: this.username,
        Pool: userPool
      };

      this.cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      this.cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function(result) {
          var accessToken = result.getAccessToken().getJwtToken();
          loginSuccess(accessToken);
        },

        onFailure: function(err) {
          showErrorMessage(err);
        },

        newPasswordRequired: function(userAttributes, requiredAttributes) {
          // the api doesn't accept this field back
          delete userAttributes.email_verified;
          requireNewPassword(userAttributes, requiredAttributes);
        }
      });
    }
  },

  mounted() {
    if (window.sessionStorage.getItem("token") !== null) {
      this.$router.push({ path: "score" });
    }
  }
};
</script>